<template>
    <div
        class="flex flex-col items-center justify-center h-full space-y-4 h-screen w-full bg-background"
    >
        <div class="flex flex-col items-center px-4 lg:px-8">
            <component :is="icon" class="size-32 text-primary mb-2 lg:mb-4" />
            <div class="space-y-4 flex flex-col items-center text-center">
                <h2 v-text="title" />
                <p v-if="description" class="text-xl" v-html="description" />
                <p
                    v-if="confirmingText"
                    class="text-sm"
                    v-text="confirmingText"
                />
                <Link :href="route('home')" class="" v-if="showRouteButton">
                    <PrimaryButton
                        size="xl"
                        class="mt-2"
                        v-text="$lang.get('Go home')"
                    />
                </Link>
            </div>
        </div>
    </div>
</template>

<script>
import { Link } from '@inertiajs/vue3'
import PrimaryButton from '@/Components/Elements/PrimaryButton.vue'
import {
    PhCloudSlash,
    PhCloudX,
    PhBulldozer,
    PhProhibit,
} from '@phosphor-icons/vue'

export default {
    components: {
        Link,
        PrimaryButton,
        PhCloudSlash,
        PhCloudX,
        PhBulldozer,
        PhProhibit,
    },

    props: {
        status: Number,
        description: String,
        title: String,
    },

    computed: {
        icon() {
            if (this.status == 503) {
                return PhBulldozer
            } else if (this.status == 404) {
                return PhCloudX
            } else if (this.status == 403) {
                return PhProhibit
            }

            // 500 and all else
            return PhCloudSlash
        },

        showRouteButton() {
            return ![500].includes(this.status)
        },

        confirmingText() {
            if ([500].includes(this.status)) {
                return this.$lang.get(
                    'We have recived the error and are working on it.'
                )
            }
            return null
        },
    },
}
</script>
